import React, { useState, useEffect } from 'react';
import ContactForm from './ContactForm.jsx';
import { useTranslation } from 'react-i18next';
import { useSendContactMailMutation } from '../../../../redux/services/mail.jsx';
import { useToastMessages } from '../../../../hooks/useToastMessages.jsx';
import { Form as AntdForm } from 'antd';

const ContactPage = () => {
  const [values, setValues] = useState(undefined);
  const { t, i18n } = useTranslation();
  const [form] = AntdForm.useForm();

  const { successMessage } = useToastMessages();

  const defaultCategory = 'study';

  useEffect(() => {
    document.title = t('Kontaktujte nás');
  }, []); // Runs on mount

  const [sendContactMail, { isSuccess: sendSuccess }] =
    useSendContactMailMutation();

  useEffect(() => {
    if (sendSuccess) {
      successMessage({
        message: t('Ďakujeme za správu!'),
        description: t('Vaša správa bola úspešne odoslaná.'),
      });
    }
  }, [sendSuccess]);

  useEffect(() => {
    if (values) {
      // Attach current locale to the data
      const locale =
        i18n.language ||
        (typeof navigator !== 'undefined' ? navigator.language : 'sk');
      sendContactMail({ ...values, locale });
    }
  }, [values]);

  useEffect(() => {
    if (sendSuccess && form && form.resetFields) {
      form.resetFields();
    }
  }, [sendSuccess]);

  const categoryOptions = [
    {
      label: t('Klub Alumni'),
      value: 'alumni',
    },
    {
      label: t('Otázka k prijímaciemu konaniu'),
      value: 'study',
    },
    {
      label: t('Pripomienky k portálu'),
      value: 'portal',
    },
    {
      label: t('Študijné záležitosti'),
      value: 'study',
    },
    {
      label: t('Technická podpora - SW a HW'),
      value: 'support',
    },
    {
      label: t('Iné'),
      value: 'other',
    },
  ];

  const initials = {
    name: undefined,
    email: undefined,
    title: undefined,
    category: defaultCategory,
    text: undefined,
  };

  return (
    <div style={{ margin: '10px' }}>
      <ContactForm
        form={form}
        categoryOptions={categoryOptions}
        initialValues={initials}
        onFinish={setValues}
      />
    </div>
  );
};

export default ContactPage;
